"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _helpers = require("../../utils/helpers");
var _globalComponentsLibrary = require("global-components-library");
var _constants = require("../../utils/constants");
require("./FileMessage.scss");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var FileMessage = function FileMessage(_ref) {
  var url = _ref.url,
    size = _ref.size,
    name = _ref.name;
  var aRef = (0, _react.useRef)(null);
  var download = function download() {
    aRef.current.click();
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-file-message"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    ref: aRef,
    href: url,
    target: "_blank",
    rel: "noreferrer",
    style: {
      display: 'none'
    }
  }, "file"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-file-icon"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon large ' + _constants.FILE_ICONS[(0, _helpers.fileExtension)(url)]
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-file-info"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-file-name"
  }, name != null ? name.replace(/%20/g, ' ').replace('FileName:', '') : (0, _helpers.getFilenameFromURL)(url)), /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-file-data"
  }, (0, _helpers.fileExtension)(url).toUpperCase(), " - ", size != null ? size.replace(/%20/g, ' ').replace('FileSize:', '') : '')), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.ButtonIcon, {
    icon: "download",
    onClick: function onClick() {
      return download();
    }
  }));
};
var _default = exports["default"] = FileMessage;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/MultimediaMessages/FileMessage.js
// module id = 1420
// module chunks = 0